module.exports = __webpack_public_path__ + "static/og-image-treble-gsm-cc462ab2362a27b12a3ade9e758e54d1.png";